<script setup>
import {ref, watch} from "vue";

const showModal = ref(false);
const showPaymentModal = ref(false);

watch(showPaymentModal, value => {
    if (value) {
        showModal.value = false;
    } else {
        showModal.value = true;
    }
})
function open() {
    showModal.value = true;
}

defineExpose({
    open
});
</script>

<template>
    <div>
        <Modal v-model="showModal" hide-footer hide-header modal-class="modal-upsell">
            <div class="modal-content__inner modal-content__inner--dark">
                <header class="modal-header">
                    <button @click="showModal = false" class="close"></button>
                </header>

                <h5 class="modal-title">Unlock Full SwitchPitch Capabilities</h5>

                <ul class="list-upsell">
                    <li>AI search with prioritized scoring</li>
                    <li>Adoption-based market intelligence</li>
                    <li>AI-generated custom reports</li>
                </ul>

                <footer class="modal-footer">
                    <a @click="showPaymentModal = true">Activate Full Access</a>
                </footer>
            </div>
        </Modal>

        <Modal v-model="showPaymentModal" hide-footer hide-header modal-class="modal-upsell-payment">
            <form class="form-v2">
                <div class="modal-upsell-payment__card">
                    <h4 class="heading4 heading5--secondary">Upgrade to SwitchPitch Pro</h4>

                    <p>Need a payment request? <a href="#">Send Invoice Instead</a></p>

                    <fieldset>
                        <legend>card details</legend>

                        <div class="form-v2__item">
                            <label>Cardholder Name</label>

                            <input type="text" />
                        </div>

                        <div class="form-v2__item">
                            <label>Card Number</label>

                            <input type="text" />
                        </div>

                        <div class="form-v2__item-cols">
                            <div class="form-v2__item">
                                <label>Exp Date</label>

                                <input type="text" placeholder="MM/YY" />
                            </div>
                            <div class="form-v2__item">
                                <label>CVV</label>

                                <input type="text" />
                            </div>
                        </div>

                        <div class="form-v2__item">
                            <label>Zip Code</label>

                            <input type="text" />
                        </div>
                    </fieldset>

                    <div class="modal-upsell-payment-note">Secure payment by Stripe</div>
                </div>
                <fieldset class="modal-upsell-payment__plan">
                    <header class="modal-header">
                        <h6 class="heading6">Your Plan</h6>
                        <button @click="showPaymentModal = false" class="close"></button>
                    </header>
                    
                    <h5 class="heading5">SwitchPitch Pro</h5>

                    <div class="plan-option selected">
                      <div class="radio checked" id="r-quarterly"></div>
                      <div class="plan-info">
                        <div class="plan-name">Quarterly</div>
                        <p>Billed every 3 months</p>
                      </div>
                      <div class="plan-price">$3,750</div>
                    </div>

                    <div class="plan-option">
                      <div class="radio" id="r-annual"></div>
                      <div class="plan-info">
                        <div class="plan-name">Annual <span class="save-badge">Save 20%</span></div>
                        <p>Billed once per year</p>
                      </div>
                      <div class="plan-price">$12,000</div>
                    </div>

                    <div class="plan-summary">
                        <div class="plan-summary__row"><span>Subtotal</span><span id="subtotal">$3,750</span></div>
                        <div class="plan-summary__row"><span>Estimated taxes</span><span id="taxes">$14</span></div>
                    </div>

                    <div class="plan-total-row"><span>Total</span><span>$3,764</span></div>

                    <button class="ui-button w-100">Submit Payment</button>
                </fieldset>
            </form>

            <!-- <div class="modal-content__inner"></div> -->
        </Modal>
    </div>
</template>

<style scoped>
</style>
